import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import {
  QueryRepository,
  QueryRepositoryUID,
} from "../repositories/QueryRepository";

export function useQueryDetails(project: number, focus: number) {
  const repository = useInjection<QueryRepository>(QueryRepositoryUID);
  const {
    data: details,
    isLoading,
    isFetching,
  } = useQuery(["/queries/details", { focus, project }], () => {
    return repository.getQueryDetails(project, focus);
  });
  return {
    details,
    loading: isLoading || isFetching,
  };
}
